<template>
  <div style="display: flex; flex-wrap: wrap;">
    <div v-for="(itemShB, indB) in shifokor" :key="indB" class="tek-item">
      <div class="chek-teksh-div">
        <div class="chek-tek">
          {{ itemShB.name }}
        </div>
      </div>
      <div class="item-child">
        <div style="padding: 5px;">
          <table class="table table-sm table-bordered striped table-style">
            <tbody>
              <tr
                v-for="(itemSh, indSh) in itemShB.bolim.doctor_category"
                :key="indSh"
                style="max-height: 30px;"
                :class="{ bg: indSh % 2 == 1 }"
              >
                <td>
                  <b-form-checkbox
                    @change="ChakkedType(itemSh, itemShB)"
                    v-model="itemSh.change"
                    style="display: flex;"
                    :value="true"
                    :unchecked-value="false"
                  >
                    {{ itemSh.name }}
                  </b-form-checkbox>
                </td>
                <td v-if="shifKorigi">
                  <span v-if="$store.state.bemor.citizen">{{
                    itemSh.citizen_price | numFormat
                  }}</span>
                  <span v-else>{{ itemSh.price | numFormat }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["shifokor", "index", "shifKorigi"],
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")),
    };
  },
  methods: {
    ChakkedType(item, itemShB) {
      if (this.$store.state.bemor.id) {
        this.$emit("itemSh", item, this.index, itemShB);
      } else {
        this.$emit("itemSh", item, this.index, itemShB);
        return (item.change = false);
      }
    }
  }
};
</script>
<style>
.tek-item {
  width: 530px;
  flex-wrap: wrap;
  margin: 5px;
  display: flex;
  padding: 5px;
  background: #f0f0f03d;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.bg {
  background: #abdfffd3;
}
.table-style {
  background: #fff;
}
.chek-teksh-div {
  display: flex;
  align-items: center;
  font-weight: 600;
  width: 100%;
}
.chek-tek {
  display: flex;
  padding: 3px 5px;
  border-radius: 5px;
  align-items: center;
  font-weight: 600;
  width: 100%;
  border: 1px solid rgb(46, 165, 255);
  font-size: 18px;
  background: rgba(7, 100, 172, 0.078);
  color: #3f51b5;
}
.tek-item {
  display: inline;
}
.item-child {
  border: 1px solid rgb(46, 165, 255);
  width: 100%;
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  margin-top: 5px;
  max-height: 470px;
}
</style>
